var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('router-view'),(_vm.devBackend)?_c('div',{staticClass:"dev-backend-badge",attrs:{"data-test":"dev-backend-badge"}},[_vm._v(_vm._s(_vm.devBackend)+" backend")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }